export const id = (photo) => photo.id;

export const src = (photo) => photo.full_path;

const DEFAULT_RENDER_STYLE = 'thumb';

function normalizeRenderStyle(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

const determineType = (photo) => {
  if (photo.image_type === '360_DEGREE') return '360';
  if (photo.full_path.split('.').pop().toLowerCase() === 'mp4') return 'video';
  return 'regular';
};

export const viewModel = (
  photo,
  { watermarkSrc = null, canDownload = false, canShare = false, canSelect = true, canFavorite = false } = {}
) => ({
  id: id(photo),
  type: determineType(photo),
  src: photo.thumb_full_path,
  watermarkSrc,
  canSelect: canSelect && (!isStockImage(photo) || getCanBeDownloaded(photo)),
  canDownload,
  canShare,
  canFavorite,
  isFavorite: Boolean(photo?.is_favorite),
  renderStyle: getRenderStyle(photo),
  clickUrl: getStockImageUrl(photo),
  opensPurchase: getOpensPurchasePage(photo),
  targetCollectionId: getTargetCollectionId(photo),
  canBeMaximized: getCanBeMaximized(photo),
});

export const fullScreenVM = (photo, { watermarkSrc = null, canShare = false, canDownload = false }) => ({
  id: id(photo),
  type: determineType(photo),
  src: photo.full_path,
  watermarkSrc,
  canShare,
  canDownload,
});

export const isPhotoById = (photoId) => (photo) => id(photo) === photoId;

export const isStockImage = ({ stock_image_uid: stockImageUid }) =>
  stockImageUid !== null && stockImageUid !== undefined;

export const getRenderStyle = (photo) => {
  const normalizedStyle = normalizeRenderStyle(photo?.stock_image_render_style || photo?.render_style);
  return normalizedStyle || DEFAULT_RENDER_STYLE;
};

export const getStockImageUrl = (photo) => {
  const value = photo?.stock_image_url;
  return typeof value === 'string' ? value.trim() : '';
};

export const getCanBeDownloaded = (photo) => {
  if (!isStockImage(photo)) return true;
  const value = photo?.stock_image_can_be_downloaded;
  return value === undefined || value === null ? true : Boolean(value);
};

export const getCanBeMaximized = (photo) => {
  if (!isStockImage(photo)) return true;
  const value = photo?.stock_image_can_be_maximized;
  return value === undefined || value === null ? true : Boolean(value);
};

export const getCanShowFavorite = (photo) => {
  if (!isStockImage(photo)) return true;
  const value = photo?.stock_image_show_favorites;
  return value === undefined || value === null ? false : Boolean(value);
};

export const getIsAvailableForPurchase = (photo) => {
  if (!isStockImage(photo)) return true;
  const value = photo?.stock_image_available_for_purchase;
  return value === undefined || value === null ? false : Boolean(value);
};

export const getOpensPurchasePage = (photo) => isStockImage(photo) && Boolean(photo?.stock_image_open_purchase_page);

// The specific package (ecommerce collection) the purchase click should open; null = package list.
export const getTargetCollectionId = (photo) =>
  getOpensPurchasePage(photo) ? Number(photo?.stock_image_target_collection_id) || null : null;

export const includesById = (ids) => (photo) => ids.includes(id(photo));

export const notIncludesById = (ids) => (photo) => !includesById(ids)(photo);
